@if (loggedUser) {
  <div class="main-nav-user menu-item logged-user">
    <div
      data-cy="main-nav-logged-user-menu"
      [matMenuTriggerFor]="loggedUserMenu"
      [ngClass]="(itemClassList$ | async) ?? []">
      <sh-user-logo
        class="user-avatar"
        fontSize="20px"
        [avatarImageType]="loggedUser.avatarType"
        [avatarVersion]="loggedUser.avatarVersion"
        [hasLogo]="loggedUser.hasAvatar"
        [id]="loggedUser.id"
        [logoTheme]="loggedUser.logoTheme"
        [userTitle]="userTitle"></sh-user-logo>
    </div>
    @if (isSuperAdmin$ | async) {
      <span>(S)</span>
    }

    <mat-menu
      class="header-menu"
      #loggedUserMenu="matMenu">
      <a
        class="header-menu-item"
        data-cy="main-nav-settings"
        mat-menu-item
        (click)="navigateToSettings()">
        {{ 'header.user-menu.settings' | transloco }}
      </a>

      <div class="my-2 header-menu-divider"></div>

      <a
        class="header-menu-item"
        data-cy="main-nav-sign-out"
        mat-menu-item
        (click)="logout()">
        {{ 'header.user-menu.logout' | transloco }}
      </a>
    </mat-menu>
  </div>
}
